export default function(el) {
  this.parseDOM(el || document)
}
